import { createTheme } from '../../helpers/create-theme.mjs';

const blockquoteTheme = createTheme({
  root: {
    base: "text-xl font-semibold italic text-gray-900 dark:text-white"
  }
});

export { blockquoteTheme };
//# sourceMappingURL=theme.mjs.map
